export default class Summary {
    constructor() {
        this.tags = 'h2,h3,h4,h5,h6';
        this.init();
    }

    init() {
        const article = document.querySelector('.article-post');
        const summaryBlocks = document.querySelectorAll('.summary-nav ul');

        if (article) {
            const htags = article.querySelectorAll(this.tags);

            if (htags.length < 2) {
                this.hideSummaryBlocks(summaryBlocks);
            } else {
                this.processHeadings(article, htags, summaryBlocks);
                this.setupObserver(article);
            }
        }
        this.setupSummaryToggle();
    }

    hideSummaryBlocks(summaryBlocks) {
        summaryBlocks.forEach((summaryBlock) => {
            summaryBlock.style.display = 'none';
        });
    }

    processHeadings(article, htags, summaryBlocks) {
        htags.forEach((heading) => {
            if (heading.closest('.block-excerpt')) return;

            const title = heading.innerText.trim();
            const id = heading.id || this.slugify(title);
            const htag = this.slugify(heading.tagName);
            const link = `<li class="${htag}"> <a href="#${id}">${title}</a></li>`;

            heading.id = id;

            summaryBlocks.forEach((summaryBlock) => {
                summaryBlock.insertAdjacentHTML('beforeend', link);
            });
        });
    }

    setupObserver(article) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const id = entry.target.getAttribute('data-id');
                    const link = document.querySelector(`.summary-nav li a[href="#${id}"]`).parentElement;

                    if (entry.isIntersecting && entry.intersectionRatio > 0) {
                        link.classList.add('is-visible');
                    } else {
                        link.classList.remove('is-visible');
                    }
                });

                this.highlightFirstActive();
            },
            { rootMargin: '-280px', threshold: 0.1 }
        );

        this.tags.split(',').forEach((tagName) => {
            const elements = article.querySelectorAll(tagName);

            elements.forEach((element) => {
                const sectionWrap = document.createElement('section');
                sectionWrap.setAttribute('data-id', element.id);
                sectionWrap.setAttribute('class', 'wrap-section');
                sectionWrap.dataset.type = tagName;

                const subordinateElements = this.nextUntil(element, tagName);
                subordinateElements.forEach((subEl) => {
                    sectionWrap.appendChild(subEl);
                });

                observer.observe(sectionWrap);

                element.insertAdjacentElement('beforebegin', sectionWrap);
                sectionWrap.insertAdjacentElement('afterbegin', element);
            });
        });
    }

    setupSummaryToggle() {
        const summaryToggle = document.querySelector('[data-toggle="summary"]');
        const summaryNav = document.querySelector('.summary-nav');

        if (summaryToggle && summaryNav) {
            summaryToggle.addEventListener('click', () => {
                summaryToggle.classList.toggle('actived');
                summaryNav.classList.toggle('show-summary-nav');
            });
        }
    }

    slugify(str) {
        return str
            .toString()
            .normalize('NFKD')
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-');
    }

    nextUntil(elem, selector, filter) {
        const siblings = [];
        elem = elem.nextElementSibling;

        while (elem) {
            if (elem.matches(selector)) break;

            if (filter && !elem.matches(filter)) {
                elem = elem.nextElementSibling;
                continue;
            }

            siblings.push(elem);
            elem = elem.nextElementSibling;
        }

        return siblings;
    }

    highlightFirstActive() {
        const summaryBlocks = document.querySelectorAll('.summary-nav ul');
        summaryBlocks.forEach((summaryBlock) => {
            const firstVisibleLink = summaryBlock.querySelector('.is-visible');

            summaryBlock.querySelectorAll('li').forEach((link) => {
                link.classList.remove('active');
            });

            if (firstVisibleLink) {
                firstVisibleLink.classList.add('active');
            }
        });
    }
}

new Summary();
